












































import { defineComponent, computed, watch, ref, Ref } from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import { CurrentUserModel } from '@/models/current-user';
import { useBroadcast, useIntersectionObservable } from '@/common/utils';
import commentModel from './commentModel';
import commentItem from './components/item.vue';
import CommentInput from './components/comment-input.vue';
import Loading from '@/components/loading/index.vue';
import { LoginSource } from '@/common/const';
import { useLog } from '@/common/log';
import Avatar from '@/components/avatar/index.vue';
import { debounce } from 'lodash';

export default defineComponent({
    components: {
        commentItem,
        CommentInput,
        Loading,
        Avatar,
    },
    props: {
        inputPlaceholder: {
            type: String,
            default: '说点什么...',
        },
        currentWork: {
            type: Object,
            required: true,
        },
        currentAuthor: {
            type: Object,
            required: true,
        },
        canAddComment: {
            type: Number,
        },
        isDark: {
            type: Boolean,
        },
        showCount: {
            type: Boolean,
        },
        logType: {
            type: String,
        },
    },
    setup(props, { emit }) {
        const user = useApolloModel(CurrentUserModel);
        const comment = useApolloModel(commentModel);
        const isSendingComment = ref(false);

        const isLogin = computed(() => !!user.userInfo.id);
        const noMore = computed(() => comment.pcursor === 'no_more');

        watch(() => props.currentWork, val => {
            if (val) {
                comment.photoId = val.id;
            }
        }, {
            immediate: true,
        });


        const broadcast = useBroadcast();
        const log = useLog();
        const sendComment = debounce(async () => {
            if (!isLogin.value) {
                return broadcast('login', {
                    // 登录源，供日志上报使用
                    source: LoginSource.COMMENT,
                });
            }
            if (comment.sendContent.trim() === '' || isSendingComment.value) {
                return;
            }
            isSendingComment.value = true;
            log({
                type: 'CLICK',
                logType: props.logType || null,
                event_name: 'POST_COMMENT_BUTTON',
            });
            await comment.addComment(
                {
                    photoId: props.currentWork.id,
                    photoAuthorId: props.currentAuthor.id,
                    content: comment.sendContent.trim(),
                    expTag: props.currentWork.expTag,
                },
                user.userInfo,
            );
            if (comment.isBlockedComment) {
                emit('block-comment');
            }
            isSendingComment.value = false;
        }, 300);

        const spinning: Ref<HTMLDivElement | null> = ref(null);
        useIntersectionObservable({
            el: spinning,
            cb: (entry: IntersectionObserverEntry) => {
                if (entry.intersectionRatio > 0 && !noMore.value) {
                    comment.getCommentList({ photoId: props.currentWork.id, append: true });
                }
            },
            options: {
                rootMargin: '0px 0px 349px 0px',
            },
        });
        return {
            user,
            comment,
            isLogin,
            sendComment,
            spinning,
            noMore,
        };
    },
});
